export const PAYMENT_METHOD_IDS = Object.freeze({
  CASH: 'cash',
  CARD: 'card',
  YAPPY: '180340A8-6952-434B-B948-2FC35199D8E4',
  CMF: 'cmf',
  PUNTOS_GORDOS: 'puntos_gordos',
})

export const PAYMENT_OPTIONS = [
  {
    id: PAYMENT_METHOD_IDS.CASH,
    label: 'PAYMENT_OPTIONS_T.CASH',
    iconType: 'cash',
    fullWidth: true,
    enabled: false,
  },
  {
    id: PAYMENT_METHOD_IDS.YAPPY,
    label: 'PAYMENT_OPTIONS_T.YAPPY',
    iconType: 'yappy',
    fullWidth: false,
    enabled: true,
  },
  {
    id: PAYMENT_METHOD_IDS.CARD,
    label: 'PAYMENT_OPTIONS_T.CARD',
    iconType: 'card',
    fullWidth: false,
    enabled: false,
  },
  {
    id: PAYMENT_METHOD_IDS.CMF,
    label: 'PAYMENT_OPTIONS_T.CMF',
    iconType: 'cmf',
    fullWidth: false,
    enabled: false,
  },
  {
    id: PAYMENT_METHOD_IDS.PUNTOS_GORDOS,
    label: 'PAYMENT_OPTIONS_T.PUNTOS_GORDOS',
    iconType: 'puntos_gordos',
    fullWidth: false,
    enabled: false,
  },
]
